import React from 'react';

/**
 * Fundo decorativo reaproveitável: blob radial + par de fios diagonais em
 * gradiente (roxo/verde), no mesmo desenho usado no Site Lukos. Cada
 * instância é posicionada a uma altura (`top`) diferente da página, para dar
 * a sensação de um fundo contínuo ao rolar — mesmo a página sendo composta
 * por várias seções, cada uma com seu próprio fundo opaco por cima.
 */
export default function GlobalPageBackground({
  top,
  height = '1400px',
}: {
  /** Deslocamento vertical (em px) a partir do topo da página. */
  top: number;
  height?: string;
}) {
  const gid = `gpb-${top}`;

  return (
    <div
      aria-hidden
      className="pointer-events-none absolute inset-x-0 overflow-hidden"
      style={{ top: `${top}px`, height }}
    >
      <div className="absolute left-1/2 top-[-20%] h-[70%] w-[90%] -translate-x-1/2 bg-[radial-gradient(closest-side,rgba(107,31,176,0.10),transparent_75%)] blur-3xl" />
      <div className="absolute left-[6%] top-[30%] h-[50%] w-[35%] bg-[radial-gradient(closest-side,rgba(149,128,255,0.09),transparent_72%)] blur-3xl" />
      <div className="absolute right-[4%] bottom-[-15%] h-[50%] w-[32%] bg-[radial-gradient(closest-side,rgba(95,171,104,0.08),transparent_72%)] blur-3xl" />

      <svg
        aria-hidden
        className="absolute inset-0 h-full w-full"
        viewBox="0 0 1440 900"
        preserveAspectRatio="none"
      >
        <defs>
          <linearGradient id={`${gid}-1`} x1="0" y1="0" x2="1" y2="1">
            <stop offset="0%" stopColor="#9f66d9" stopOpacity="0" />
            <stop offset="50%" stopColor="#6b1fb0" stopOpacity="0.18" />
            <stop offset="100%" stopColor="#6b1fb0" stopOpacity="0" />
          </linearGradient>
          <linearGradient id={`${gid}-2`} x1="1" y1="0" x2="0" y2="1">
            <stop offset="0%" stopColor="#5fab68" stopOpacity="0" />
            <stop offset="55%" stopColor="#5fab68" stopOpacity="0.14" />
            <stop offset="100%" stopColor="#5fab68" stopOpacity="0" />
          </linearGradient>
        </defs>
        <path d="M-60 780 L 920 -60" stroke={`url(#${gid}-1)`} strokeWidth="1.5" fill="none" />
        <path d="M1560 640 L 760 -60" stroke={`url(#${gid}-2)`} strokeWidth="1" fill="none" />
      </svg>
    </div>
  );
}
